module.exports = __webpack_public_path__ + "img/product11p.056aea8e.png";